var initContactForm = function initContactForm() {
  // Function to update range value display
  function updateRangeValue(rangeInput) {
    var valueDisplay = document.getElementById(rangeInput.id + '_value');
    if (valueDisplay) {
      valueDisplay.textContent = rangeInput.value;
    }

    // Update CSS custom property for progress bar
    var min = rangeInput.min || 0;
    var max = rangeInput.max || 100;
    var val = rangeInput.value;
    var percentage = (val - min) / (max - min) * 100;
    rangeInput.style.setProperty('--range-progress', percentage + '%');
  }

  // Function to close form errors
  function closeFormErrors() {
    var formErrors = document.getElementById("form-errors");
    if (formErrors) {
      formErrors.style.opacity = "0";
      formErrors.style.transition = "opacity 0.3s ease";
      setTimeout(function () {
        formErrors.style.display = "none";
      }, 300);

      // Limpiar URL también
      var cleanUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
      history.replaceState({}, document.title, cleanUrl);
    }
  }

  // Make updateRangeValue globally accessible for inline handlers
  window.updateRangeValue = updateRangeValue;
  window.closeFormErrors = closeFormErrors;
  document.addEventListener("DOMContentLoaded", function () {
    // Initialize range inputs
    var rangeInputs = document.querySelectorAll('.form-range');
    rangeInputs.forEach(function (rangeInput) {
      // Set initial value display and progress
      updateRangeValue(rangeInput);

      // Add event listeners for real-time updates
      rangeInput.addEventListener('input', function () {
        updateRangeValue(this);
      });
      rangeInput.addEventListener('change', function () {
        updateRangeValue(this);
      });
    });

    // Smart validation - only show errors for date, number, range after blur
    var smartValidationFields = document.querySelectorAll('input[type="date"], input[type="number"], input[type="range"]');
    smartValidationFields.forEach(function (field) {
      field.addEventListener('blur', function () {
        this.classList.add('touched');
      });
      field.addEventListener('focus', function () {
        if (this.classList.contains('touched')) {
          // Remove touched class temporarily while editing
          this.classList.remove('touched');
        }
      });
    });

    // Email validation enhancement
    var emailInputs = document.querySelectorAll('input[type="email"]');
    emailInputs.forEach(function (emailInput) {
      emailInput.addEventListener('blur', function () {
        var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (this.value && !emailPattern.test(this.value)) {
          this.setCustomValidity('Please enter a valid email address');
        } else {
          this.setCustomValidity('');
        }
      });
      emailInput.addEventListener('input', function () {
        // Clear custom validity on input to allow HTML5 validation
        this.setCustomValidity('');
      });
    });

    // Phone validation enhancement  
    var phoneInputs = document.querySelectorAll('input[type="tel"]');
    phoneInputs.forEach(function (phoneInput) {
      phoneInput.addEventListener('input', function () {
        // Allow only numbers, +, -, spaces, and parentheses
        this.value = this.value.replace(/[^0-9+\-\s()]/g, '');
      });
      phoneInput.addEventListener('blur', function () {
        var phonePattern = /^[\d+\-\s()]{10,}$/;
        if (this.value && !phonePattern.test(this.value.replace(/[\s\-()]/g, ''))) {
          this.setCustomValidity('Please enter a valid phone number');
        } else {
          this.setCustomValidity('');
        }
      });
    });

    // Checkbox group validation - siguiendo el patrón oficial de Shopify
    var checkboxGroups = document.querySelectorAll('.checkbox-group[data-required="true"]');
    checkboxGroups.forEach(function (group) {
      var checkboxes = group.querySelectorAll('input[type="checkbox"]');
      if (checkboxes.length > 0) {
        // Function to validate the group
        var validateGroup = function validateGroup() {
          var checkedBoxes = group.querySelectorAll('input[type="checkbox"]:checked');
          var isValid = checkedBoxes.length > 0;

          // Clear all previous custom validity messages
          checkboxes.forEach(function (cb) {
            cb.setCustomValidity('');
          });

          // If invalid, set custom validity on all unchecked boxes
          if (!isValid) {
            checkboxes.forEach(function (cb) {
              if (!cb.checked) {
                cb.setCustomValidity('Please select at least one option');
              }
            });
            group.classList.add('has-error');
          } else {
            group.classList.remove('has-error');
          }
          return isValid;
        }; // Add event listeners to all checkboxes in the group
        checkboxes.forEach(function (checkbox) {
          checkbox.addEventListener('change', function () {
            validateGroup();
          });

          // Handle individual validation
          checkbox.addEventListener('invalid', function (e) {
            var checkedBoxes = group.querySelectorAll('input[type="checkbox"]:checked');
            if (checkedBoxes.length === 0) {
              // Prevent default browser validation message on all but first
              var firstCheckbox = group.querySelector('input[type="checkbox"]');
              if (this !== firstCheckbox) {
                e.preventDefault();
              }
              group.classList.add('has-error');
            }
          });
        });

        // Initial validation
        validateGroup();
      }
    });

    // Override form submission to handle checkbox validation
    var contactForm = document.querySelector('.contact-form');
    if (contactForm) {
      contactForm.addEventListener('submit', function (e) {
        var hasValidationErrors = false;

        // Check all required checkbox groups
        checkboxGroups.forEach(function (group) {
          var checkboxes = group.querySelectorAll('input[type="checkbox"]');
          var checkedBoxes = group.querySelectorAll('input[type="checkbox"]:checked');
          if (checkedBoxes.length === 0) {
            hasValidationErrors = true;

            // Set validation error on all checkboxes
            checkboxes.forEach(function (cb) {
              cb.setCustomValidity('Please select at least one option');
            });
            group.classList.add('has-error');

            // Focus the first checkbox for better UX
            if (checkboxes[0] && !e.defaultPrevented) {
              checkboxes[0].focus();
            }
          } else {
            // Clear validation if valid
            checkboxes.forEach(function (cb) {
              cb.setCustomValidity('');
            });
            group.classList.remove('has-error');
          }
        });
        if (hasValidationErrors) {
          e.preventDefault();
          return false;
        }
      });
    }

    // Clean form fields on success
    var successMessage = document.querySelector(".form-success");
    if (successMessage) {
      var _form = document.querySelector(".contact-form");
      if (_form) {
        // Clean fields but keep success message visible
        var inputs = _form.querySelectorAll('input:not([type="hidden"]), textarea, select');
        inputs.forEach(function (input) {
          if (input.type !== "hidden") {
            if (input.type === "checkbox" || input.type === "radio") {
              input.checked = false;
            } else {
              input.value = "";
            }
          }
        });

        // Remove error states
        var errorGroups = _form.querySelectorAll('.checkbox-group.has-error');
        errorGroups.forEach(function (group) {
          group.classList.remove('has-error');
        });

        // Scroll to success message
        successMessage.scrollIntoView({
          behavior: "smooth"
        });
      }
    }

    // Clean URL if there are form errors
    var formErrors = document.querySelector(".form-errors");
    if (formErrors) {
      // Check if the URL contains form parameters
      var urlParams = new URLSearchParams(window.location.search);
      var hasFormParams = urlParams.has("form_type") || Array.from(urlParams.keys()).some(function (key) {
        return key.startsWith("contact[");
      });
      if (hasFormParams) {
        // Clean URL without reloading the page after 2 seconds
        setTimeout(function () {
          var cleanUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
          history.replaceState({}, document.title, cleanUrl);
        }, 2000);

        // Auto-hide errors after 8 seconds if not closed manually
        setTimeout(function () {
          if (formErrors && formErrors.style.display !== "none") {
            closeFormErrors();
          }
        }, 8000);
      }
    }

    // Reduce opacity of errors when user starts correcting
    var form = document.querySelector(".contact-form");
    if (form && formErrors) {
      var _inputs = form.querySelectorAll("input, textarea, select");
      _inputs.forEach(function (input) {
        input.addEventListener("focus", function () {
          if (formErrors && formErrors.style.display !== "none") {
            formErrors.style.opacity = "0.6";
            formErrors.style.transition = "opacity 0.3s ease";
          }
        });
      });
    }
  });
};
export { initContactForm };